export default {
    remove: 'Entfernen',
    save: 'Speichern',
    cancel: 'Abbrechen',
    loading: 'Laden…',
    value: 'Wert',
    'action-bar.collapse': 'Einklappen',
    'action-bar.expand': 'Ausklappen',
    'action-bar.actions': 'Aktionen',
    'callout.note': 'Hinweis',
    'callout.important': 'Wichtig',
    'callout.tip': 'Tipp',
    'callout.caution': 'Vorsicht',
    'callout.warning': 'Warnung',
    'collapsible-section.open': '{ header } Bereich öffnen',
    'collapsible-section.close': '{ header } Bereich schließen',
    'date-picker.today': 'Heute',
    'date-picker.month.heading': 'Monat',
    'date-picker.quarter.heading': 'Quartal',
    'date-picker.year.heading': 'Jahr',
    'chip-set.clear-all': 'Alles löschen',
    'snackbar.dismiss': 'Schließen',
    'file.drag-and-drop-tips':
        'Ziehen Sie Ihre Datei hierher oder klicken Sie, um zu durchsuchen.',
    'file-viewer.message.unsupported-filetype':
        'Für diesen Dateityp kann keine Vorschau angezeigt werden.',
    'file-viewer.message.try-other-options':
        'Laden Sie die Datei herunter oder öffnen Sie sie in einem neuen Tab.',
    'file-viewer.download': 'Herunterladen',
    'file-viewer.exit-fullscreen': 'Vollbildmodus beenden',
    'file-viewer.open-in-fullscreen': 'Im Vollbildmodus öffnen',
    'file-viewer.open-in-new-tab': 'In einem neuen Tab öffnen',
    'file-viewer.more-actions': 'Mehr…',
    'editor-menu.bold': 'Fett',
    'editor-menu.italic': 'Kursiv',
    'editor-menu.strikethrough': 'Durchgestrichen',
    'editor-menu.h1': 'Überschrift 1',
    'editor-menu.h2': 'Überschrift 2',
    'editor-menu.h3': 'Überschrift 3',
    'editor-menu.bulleted-list': 'Aufzählungsliste',
    'editor-menu.numbered-list': 'Nummerierte Liste',
    'editor-menu.blockquote': 'Zitatblock',
    'editor-menu.link': 'Link',
    'editor-link-menu.text': 'Text',
    'editor-link-menu.link': 'Link',
    'editor-menu.code-block': 'Codeblock',
    'editor-menu.code': 'Code',
    'editor-image-view.loading': 'Lade Bild: { filename }...',
    'editor-image-view.failed':
        'Beim Laden des Bildes ist etwas schief gelaufen: { filename }',
    'editor-image-view.success': 'Bild: { filename } ist bereit',
    'editor-image-view.resize-handle':
        'Ziehen Sie nach rechts oder links, um die Größe des Bildes zu ändern.',
    'progress-bar': 'Fortschrittsbalken',
    'ai-avatar.label': 'KI-Avatar',
    'ai-avatar.thinking': 'denkt',
    'table.select-all': 'Alle Zeilen auswählen',
    'table.select-row': 'Diese Zeile auswählen',
    'profile-picture.remove': 'Ausgewähltes Bild entfernen',
    'profile-picture.unsupported-preview.title':
        'Nicht unterstütztes Bildformat',
    'profile-picture.unsupported-preview.description':
        'Wir können das ausgewählte Bild in diesem Browser nicht anzeigen. Bitte wählen Sie eine andere Bilddatei.',
};
